import { differenceInDays } from 'date-fns';
import type { LodasPersonData } from '../../server/lodas/LodasPersonData.js';
import { formatDatum } from '../../server/lodas/transformers.js';
import { getLodasAbwesenheitsKey } from '../abwesenheit.js';

function splitKrankheit(sickDayInARow: number, start: Date, end: Date) {
  const daysLeftInGrund47 = 42 - sickDayInARow;
  // Kalendertage, die Grenzen werden also auf dem UTC-Raster gerechnet
  const year = start.getUTCFullYear();
  const month = start.getUTCMonth();
  const day = start.getUTCDate();

  return {
    start: start,
    end: new Date(Date.UTC(year, month, day + daysLeftInGrund47)),
    start47: new Date(Date.UTC(year, month, day + daysLeftInGrund47 + 1)),
    end47: end,
  };
}

export function generateFehlzeitenData(satzNummer: string, persons: LodasPersonData[]) {
  const mappedLine: string[] = [];

  for (const person of persons) {
    if (!person.fehlzeiten.length) continue;

    let sickDayInARow = 0;
    let lastSickDay: null | Date = null;

    for (let i = 0; i < person.fehlzeiten.length; i++) {
      const info = person.fehlzeiten[i];
      if (!info) continue;

      let sickDayInARowSave = sickDayInARow;

      if (info.grund === 'Krankheit') {
        if (!lastSickDay) {
          lastSickDay = info.end;
          sickDayInARow += differenceInDays(info.end, info.start);
        } else {
          if (differenceInDays(lastSickDay, info.start) <= 1) {
            const overlap = differenceInDays(lastSickDay, info.start) - 1;
            lastSickDay = info.end;
            sickDayInARow += differenceInDays(info.end, info.start) + overlap;
          } else {
            lastSickDay = info.end;
            sickDayInARow = differenceInDays(info.end, info.start);
          }
        }
      } else {
        lastSickDay = null;
        sickDayInARow = 0;
        sickDayInARowSave = 0;
      }

      if (sickDayInARow > 42) {
        const { start, end, start47, end47 } = splitKrankheit(sickDayInARowSave, info.start, info.end);
        mappedLine.push(
          `${satzNummer};"${person.personalNr}";"${person.lodasPersonalNr}";${formatDatum(start)};${formatDatum(
            end,
          )};103;`,
        );
        mappedLine.push(
          `${satzNummer};"${person.personalNr}";"${person.lodasPersonalNr}";${formatDatum(start47)};${formatDatum(
            end47,
          )};41;`,
        );
      } else {
        const grund = getLodasAbwesenheitsKey(info.grund);
        mappedLine.push(
          `${satzNummer};"${person.personalNr}";"${person.lodasPersonalNr}";${formatDatum(info.start)};${formatDatum(
            info.end,
          )};${grund};`,
        );
      }
    }
  }

  return mappedLine.join('\r\n');
}
